import { omit } from 'lodash';
export function stripStatus(parsedHours) {
  return parsedHours.map(parsed => omit(parsed, 'status'));
}